// Types
import * as Types from '../types'
import { requestActionProps, requestGenerate, successGenerate } from "../../common";
import api from '../../../services/api'
import { callbackProps, ID, ISchool, IClassroom, IClassroomCurriculum } from "../../../constants";

const actionCreateSchool = (
    payload: ISchool,
    callback?: (a: callbackProps) => void
): requestActionProps => ({
  payload: { data: payload },
  type: requestGenerate(Types.REQUEST),
  api: api.createSchool,
  callback,
});

const actionGetSchool = (
  payload:any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.getSchoolById,
  payload: { data: payload },
  callback,
});

const actionGetStaffClassrooms = (
  payload:any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.SET_CLASSROOMS),
  api: api.getStaffClassrooms,
  payload: { data: new URLSearchParams(payload) },
  callback,
});

export {
  actionCreateSchool,
  actionGetSchool
};
